// log
import store from "../store";

const fetchDataRequest = () => {
  return {
    type: "CHECK_DATA_REQUEST",
  };
};

const fetchDataSuccess = (payload) => {
  return {
    type: "CHECK_DATA_SUCCESS",
    payload: payload,
  };
};

const fetchDataFailed = (payload) => {
  return {
    type: "CHECK_DATA_FAILED",
    payload: payload,
  };
};

export const fetchData = (account) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest());
    try {
      let stakedTokens = await store
        .getState()
        .blockchain.tdgStakingPool.methods.getStakedNFTs()
        .call({from: account});
      let rpBalance = await store
        .getState()
        .blockchain.RUGPULL.methods.balanceOf(account)
        .call() / 10**18;
      rpBalance = parseFloat(rpBalance).toFixed(2);
      let tdgBalance = await store
        .getState()
        .blockchain.DETECTIVESGUILD.methods.balanceOf(account)
        .call() / 10**18;
        tdgBalance = parseFloat(tdgBalance).toFixed(2);
      let myStakingBalance = await store
        .getState()
        .blockchain.tdgStakingPool.methods.stakingBalance(account)
        .call();
      let totalStaked = await store
        .getState()
        .blockchain.tdgStakingPool.methods.getTotalStaked()
        .call();
      let rewardTotal = 0;
      if(totalStaked > 0){
        rewardTotal = await store
          .getState()
          .blockchain.tdgStakingPool.methods.calculateRewardTotal(account)
          .call();
        rewardTotal = rewardTotal / 10**18;
      }
      let rewardTime = await store
        .getState()
        .blockchain.tdgStakingPool.methods.calculateRewardTime(account)
        .call();
      let rewardBalance = await store
        .getState()
        .blockchain.tdgStakingPool.methods.getDappBalance(account)
        .call();
      let weeklyEmmissions = await store
        .getState()
        .blockchain.tdgStakingPool.methods.getWeeklyEmmissions()
        .call() / 10**18;
      weeklyEmmissions = 1923076.92307692;
      weeklyEmmissions = parseFloat(weeklyEmmissions).toFixed(2);
      let dailyEmmissions = await store
        .getState()
        .blockchain.tdgStakingPool.methods.getDailyEmmissions()
        .call() / 10**18;
        dailyEmmissions = 273972.6027392726;
        dailyEmmissions = parseFloat(dailyEmmissions).toFixed(2);
      let totalSupplyRPD = await store
        .getState()
        .blockchain.rugpullDetectiveNFT.methods.totalSupply()
        .call();
      let totalSupplySH = await store
        .getState()
        .blockchain.surelockHolmesNFT.methods.totalSupply()
        .call();
      let totalSupplyCS = await store
        .getState()
        .blockchain.carmellaSantiagoNFT.methods.totalSupply()
        .call();
      let totalSupplyJB = await store
        .getState()
        .blockchain.janBondNFT.methods.totalSupply()
        .call();
      let totalSupplyMB = await store
        .getState()
        .blockchain.moBoostedNFT.methods.totalSupply()
        .call();
      let rpTokens = await store
        .getState()
        .blockchain.rugpullDetectiveNFT.methods.getMyTokens(account)
        .call();
      let shTokens = await store
        .getState()
        .blockchain.surelockHolmesNFT.methods.getMyTokens(account)
        .call();
      let csTokens = await store
        .getState()
        .blockchain.carmellaSantiagoNFT.methods.getMyTokens(account)
        .call();
      let jbTokens = await store
        .getState()
        .blockchain.janBondNFT.methods.getMyTokens(account)
        .call();
      let mbTokens = await store
        .getState()
        .blockchain.moBoostedNFT.methods.getMyTokens(account)
        .call();
      let claimTokens = rewardTotal + rewardBalance;
      claimTokens = parseFloat(claimTokens).toFixed(2);
      rewardTotal = parseFloat(rewardTotal).toFixed(2);
      rewardBalance = parseFloat(rewardBalance).toFixed(2);
      let allTokens = [...rpTokens, ...shTokens, ...csTokens, ...jbTokens, ...mbTokens];


      dispatch(
        fetchDataSuccess({
          rpBalance,
          tdgBalance,
          myStakingBalance,
          totalStaked,
          rewardTotal,
          rewardTime,
          rewardBalance,
          weeklyEmmissions,
          dailyEmmissions,
          claimTokens,
          totalSupplyRPD,
          totalSupplySH,
          totalSupplyCS,
          totalSupplyJB,
          totalSupplyMB,
          allTokens,
          rpTokens,
          shTokens,
          csTokens,
          jbTokens,
          mbTokens,
          stakedTokens,
        })
      );
    } catch (err) {
      console.log(err);
      dispatch(fetchDataFailed("Could not load data from contract."));
    }
  };
};
